module.exports = __webpack_public_path__ + "img/HumanMale_Bandit.8847165b.png";